import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import moment from 'moment';

export interface InputDateTimeSignature {
  Args: {
    value: string;
    onChange: (value: string) => void;
  };
  Element: HTMLInputElement;
}

export interface InputDateOnlySignature {
  Args: {
    value: string;
    onChange: (value: string) => void;
  };
  Element: HTMLInputElement;
}

export class InputDateTime extends Component<InputDateTimeSignature> {
  get dateTimeLocal() {
    const value = this.args.value;
    if (!value) {
      return '';
    }

    return moment(value).local().format('YYYY-MM-DDTHH:mm');
  }

  setDateTimeLocal = (event: Event) => {
    const target = event.target as HTMLInputElement;
    const value = target.value;
    const isoString = value ? moment(value).toISOString() : null;
    this.args.onChange(isoString || '');
  };

  <template>
    <input
      type="datetime-local"
      value={{this.dateTimeLocal}}
      {{on "change" this.setDateTimeLocal}}
      ...attributes
    />
  </template>
}

export class InputDateOnly extends Component<InputDateOnlySignature> {
  get dateOnly() {
    const value = this.args.value;
    if (!value) {
      return '';
    }

    return moment(value).local().format('YYYY-MM-DD');
  }

  setDateOnly = (event: Event) => {
    const target = event.target as HTMLInputElement;
    const value = target.value;
    const isoString = value ? moment(value).toISOString() : null;
    this.args.onChange(isoString || '');
  };

  <template>
    <input
      type="date"
      value={{this.dateOnly}}
      {{on "change" this.setDateOnly}}
      ...attributes
    />
  </template>
}
